// Pick localized fields from a blog post returned by the API.
// Falls back to FR (canonical) if the requested language is missing.
export function localizePost(post, lang) {
  if (!post) return post;
  const t = post.i18n && (post.i18n[lang] || post.i18n.fr);
  if (!t) return post;
  return {
    ...post,
    title: t.title || post.title,
    excerpt: t.excerpt || post.excerpt,
    content: t.content || post.content,
    category: t.category || post.category,
  };
}

// Map LanguageContext language codes to BCP-47 locale codes used by Intl APIs.
export const DATE_LOCALES = {
  fr: "fr-BE",
  nl: "nl-BE",
  en: "en-GB",
  it: "it-IT",
};
